var _defs, _rect, _path, _path2, _path3, _path4, _g, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccordionLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 120.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f242f;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 730.9,
    y: 2.9,
    width: 21.1,
    height: 115.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m499.6,2.9h52.8c24.5,0,36.7,16.9,36.7,34.2,0,14.5-7.9,27.8-23.4,32.9l29.8,48h-24.7l-25.8-43.7h-24.3v43.7h-21.1V2.9Zm48.9,53.3c12.7,0,19.1-7.4,19.1-17.3s-6.1-16.3-18.6-16.3h-28.3v33.5h27.8v.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m614.6,2.9h41.3c38.2,0,55.9,25.3,55.9,55.6s-18.4,59.5-58.7,59.5h-38.5V2.9Zm38.6,95.4c26.3,0,37-17.6,37-39.3s-9.7-36.3-34.4-36.3h-20.2v75.6h17.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m771,60.4c0-33.1,20.2-60.4,56.9-60.4s56.9,27.3,56.9,60.4-20.2,60.5-56.9,60.5-56.9-27.5-56.9-60.5Zm56.9,41.1c23.4,0,35.4-17.8,35.4-41.1s-12-40.9-35.4-40.9-35.4,17.6-35.4,40.9c.1,23.3,12.1,41.1,35.4,41.1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m366.7,60.4c0-33.1,20.3-60.4,56.9-60.4s56.9,27.3,56.9,60.4-20.2,60.5-56.9,60.5-56.9-27.5-56.9-60.5Zm56.9,41.1c23.4,0,35.4-17.8,35.4-41.1s-12-40.9-35.4-40.9-35.4,17.6-35.4,40.9c.1,23.3,12.1,41.1,35.4,41.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.6 2.9 46.5 2.9 85.3 98.8 49.3 98.8 41.5 118 115.1 118 68.6 2.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.8 26.9 0 118 22.1 118 47.8 54.2 36.8 26.9"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m243.2,61.2c0-36.2,22.5-61.2,57.2-61.2,27.5,0,48.2,15.6,49.7,42.1h-21.5c-1.2-14.1-12.3-22.7-28.8-22.7-22.5,0-35.2,16.6-35.2,40.9,0,21.9,10.2,41.1,34.9,41.1,16.4,0,28.9-8.6,29.6-26.1h21.5c-1.3,30.3-24,45.6-52.6,45.6-37.7,0-54.8-28.5-54.8-59.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.2,61.2C120.2,25,142.7,0,177.4,0c27.5,0,48.2,15.6,49.7,42.1h-21.5c-1.2-14.1-12.3-22.7-28.8-22.7-22.5,0-35.2,16.6-35.2,40.9,0,21.9,10.2,41.1,34.9,41.1,16.4,0,28.9-8.6,29.6-26.1h21.5c-1.3,30.3-24,45.6-52.6,45.6-37.7,0-54.8-28.5-54.8-59.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m904,2.9h24.8l50.2,82.4V2.9h21.1v115.1h-24.2l-50.9-83.4v83.4h-21V2.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionLogo);
export default __webpack_public_path__ + "static/media/accordion_logo.c68f32acc8f51d13edf83b2310d580a9.svg";
export { ForwardRef as ReactComponent };